var map = {
	"./28-global-platinum-front@2x.png": "e0e9",
	"./28d-card-awards@2x.png": "fMN+",
	"./28d-card-canstar-award@2x.png": "1m56",
	"./card-tile-background.jpg": "QtQ4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "CDwC";